import React from 'react';
import { Link } from './common/Link';
import { Text } from './typography/Text';
import { Address } from './footer/Address';
import { ContactInfo } from './footer/ContactInfo';

interface FooterProps {
  className?: string;
}

export function Footer({ className = '' }: FooterProps) {
  return (
    <footer className={`border-t ${className}`}>
      <div className="max-w-7xl mx-auto px-8 py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Legal Column */}
          <div className="flex flex-col space-y-2">
            <Text className="font-medium mb-2">Legal</Text>
            <Text>
              <Link href="/terms" className="text-gray-600 hover:text-gray-900">
                Terms of Policy
              </Link>
            </Text>
            <Text>
              <Link href="/privacy" className="text-gray-600 hover:text-gray-900">
                Privacy Policy
              </Link>
            </Text>
            <ContactInfo />
          </div>
          
          {/* Address Column */}
          <div className="flex flex-col space-y-6">
            <Address />
          </div>
        </div>
      </div>
    </footer>
  );
}